import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Box, IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useData } from '../context/DataContext';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const CostoDistribucionVentasBar = ({ selectedIndustries = [], onBarClick = () => {} }) => {
  const [infoOpen, setInfoOpen] = useState(false);
  const { getDistributionCost, dataReady } = useData();

  // Get data from Excel (3 years)
  const excelData = dataReady ? getDistributionCost() : { labels: [], data2022: [], data2023: [], data2024: [] };

  // Use Excel data or fallback
  const allLabels = excelData.labels.length > 0
    ? excelData.labels
    : ['Alimentos', 'Servicios Logísticos', 'Automotriz', 'Construcción', 'Retail', 'Manufactura', 'Sector salud/ Farmacéuticas'];

  const allData2022 = excelData.data2022.length > 0 ? excelData.data2022 : [6, 22, 10, 6, 4, 6, 5];
  const allData2023 = excelData.data2023.length > 0 ? excelData.data2023 : [15, 15, 14, 11, 15, 4, 3];
  const allData2024 = excelData.data2024.length > 0 ? excelData.data2024 : [18, 10, 9, 19, 12, 9, 5];

  const labels = selectedIndustries.length > 0 ? selectedIndustries : allLabels;

  const getValuesForLabels = (allValues) => labels.map((label) => {
    const index = allLabels.indexOf(label);
    return index !== -1 ? allValues[index] : 0;
  });

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: '2023',
        data: getValuesForLabels(allData2022),
        backgroundColor: '#A2AEBB',
      },
      {
        label: '2024',
        data: getValuesForLabels(allData2023),
        backgroundColor: '#476A8E',
      },
      {
        label: '2025',
        data: getValuesForLabels(allData2024),
        backgroundColor: '#1F3D58',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}%`,
        },
      },
      datalabels: {
        color: '#000',
        font: {
          weight: 'bold',
          size: 10,
        },
        anchor: 'end',
        align: 'end',
        offset: 5,
        clip: false,
        formatter: (value) => `${value}%`,
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        max: 25,
        ticks: {
          stepSize: 5,
        },
        title: {
          display: true,
          text: 'Porcentaje (%)',
        },
      },
      y: {
        ticks: {
          font: {
            size: 12,
          },
        },
        title: {
          display: true,
          text: 'Industria',
        },
      },
    },
  };

  const infoContent = {
    formula: 'Costo de distribución como % de las ventas totales = [(Costo almacenamiento + Embalaje + Costo de transporte) / Ventas netas] x 100',
    description: 'Muestra todos los costos relacionados con la distribución, desde el almacén hasta el cliente.',
  };

  return (
    <div style={{ maxWidth: '800px', height: '500px', margin: '0 auto', padding: '20px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Bar data={chartData} options={options} />
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
          <p><strong>Fórmula:</strong> {infoContent.formula}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CostoDistribucionVentasBar;
